<template>
    <div class="tag copy-s bold">
        {{ value }}
        <FeatherIcon v-if="removable" name="x" @click="$emit('remove', value)" />
    </div>
</template>

<script>
import FeatherIcon from '@/components/FeatherIcon'
export default {
    name: 'Tag',
    components: {
        FeatherIcon,
    },
    props: {
        removable: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            required: true,
            default: 'Value',
        },
    },
}
</script>

<style scoped lang="sass">
.tag + .tag
    margin-left: $xs
.tag
    display: inline-flex
    height: 26px
    background: $gray-1
    border-radius: 8px
    padding: 0 $s
    align-items: center

    .feather-icon
        margin-left: $xxs
        cursor: pointer
        width: 1.8rem
        height: 1.8rem
</style>
